@if (!loading) {
  <div class="connected-wrapper">
    <div>
      <p class="description">
        {{ "CONNECT_DEVICE_INFO" | translate }}
      </p>
      <h6>{{ "CONNECTED_DEVICES" | translate }}</h6>
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th>{{ "NAME" | translate }}</th>
              <th>{{ "DEVICE_ID" | translate }}</th>
              <th>{{ "DEVICE_TYPE" | translate }}</th>
              <th>{{ "ALERT_TYPE" | translate }}</th>
              @if (editMode) {
                <th></th>
              }
            </tr>
          </thead>
          <tbody>
            @for (dev of connectedDevices; track dev) {
              <tr>
                <td>{{ dev.name || '-' }}</td>
                <td>{{ dev.id }}</td>
                <td>{{ getDeviceType(dev.deviceType) }}</td>
                <td>{{ dev.activationName || '-' }}</td>
                @if (editMode) {
                  <td>
                    <button class="remove-btn" (click)="removeDevice(dev.id, dev.name)"> <mat-icon>close_small</mat-icon></button>
                  </td>
                }
              </tr>
            }
            @if (!loading && connectedDevices.length === 0) {
              <tr>
                <td colspan="4" class="empty">{{ "NO_CONNECTED_DEVICE" | translate }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <div class="actions">
      @if (connectRowVisible) {
        <div class="connect-row" [class.closing]="connectRowClosing">
          <mat-form-field class="connect-select">
            <mat-select
              placeholder="{{ 'FILTER_DEVICE' | translate }}"
              [(ngModel)]="selectedDeviceArray[0]"
              (ngModelChange)="onDeviceChange($event)"
              (openedChange)="onDeviceSelectOpenedChange($event)">
              <input
                class="select-search-input"
                type="text"
                [(ngModel)]="deviceSearchText"
                (ngModelChange)="filterDeviceList()"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                placeholder="{{ 'SEARCH' | translate }}" />
              @for (dev of filteredDeviceList; track dev) {
                <mat-option [value]="dev">{{ dev.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="connect-select">
            <mat-select
              placeholder="{{ 'FILTER_ACTIVATION' | translate }}"
              [(ngModel)]="selectedActivationArray"
              [disabled]="!selectedDeviceArray.length"
              multiple>
              @for (act of activationList; track act.id) {
                <mat-option [value]="act.id">{{ act.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button class="btn btn-primary" (click)="connectDevice()" [disabled]="!selectedDeviceArray?.length || !selectedActivationArray?.length || !activationList?.length">
            + {{ "CONNECT_DEVICE" | translate}}
          </button>
        </div>
      }
      <button class="btn btn-primary" (click)="toggleEditMode()" style="align-self: flex-start;">
        {{ (editMode ? "DONE" : "EDIT") | translate }}
      </button>
    </div>
  </div>
}
@if (loading) {
  <div>
    <img
      class="fadeLoader centerLoader logoSmall"
      src="assets/img/loading_logo.svg" />
    </div>
  }